/** HTTP status carried by an OpenAI-SDK-shaped error, regardless of which
 *  bundled copy of the `openai` package constructed it. `instanceof` checks
 *  against openai's error classes are unreliable here: the workspace resolves
 *  one copy of `openai` while @azure/ai-projects nests another, and a client
 *  obtained through the Azure SDK throws the nested copy's classes. */
export function openAIErrorStatus(err: unknown): number | undefined {
  if (typeof err !== "object" || err === null) return undefined;
  const status = (err as { status?: unknown }).status;
  return typeof status === "number" ? status : undefined;
}

/** Convenience predicate over openAIErrorStatus — reads cleaner at call sites
 *  that only need a yes/no answer for one status code. */
export function isOpenAIStatus(err: unknown, status: number): boolean {
  return openAIErrorStatus(err) === status;
}
